import { render, staticRenderFns } from "./SubCategory.vue?vue&type=template&id=965c519e&"
import script from "./SubCategory.vue?vue&type=script&lang=js&"
export * from "./SubCategory.vue?vue&type=script&lang=js&"
import style0 from "./SubCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports